export default __webpack_public_path__ + "static/media/de_flag.9b710f46.svg";